import { render, staticRenderFns } from "./inputCounter.vue?vue&type=template&id=20be9082&scoped=true&"
import script from "./inputCounter.vue?vue&type=script&lang=js&"
export * from "./inputCounter.vue?vue&type=script&lang=js&"
import style0 from "./inputCounter.vue?vue&type=style&index=0&id=20be9082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be9082",
  null
  
)

export default component.exports